import { getBootstrap } from "@/lib/bootstrap";
import { useMainMenu } from "@/hooks/useMainMenu";
import { useSiteOptions } from "@/hooks/useSiteOptions";

const SiteFooter = () => {
  const year = new Date().getFullYear();
  const menu = useMainMenu();
  const { phone, email, address, hours, rbq, privacy } = useSiteOptions();
  const siteName = getBootstrap().site.name || "Site";

  return (
    <footer className="bg-background border-t border-border/40">
      <div className="container py-16">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <a href="/" className="font-display font-black text-2xl uppercase leading-tight block">
              {siteName}
            </a>
            {rbq && (
              <p className="mt-4 text-sm">
                <span className="text-primary font-bold">RBQ :</span>{" "}
                <span className="text-foreground/90">{rbq}</span>
              </p>
            )}
          </div>

          <div className="space-y-8">
            {address && (
              <div>
                <h3 className="label-orange mb-3">Adresse</h3>
                <p className="text-sm leading-relaxed text-foreground/90 whitespace-pre-line">
                  {address}
                </p>
              </div>
            )}
            {hours && (
              <div>
                <h3 className="label-orange mb-3">Heures d'ouverture</h3>
                <p className="text-sm text-foreground/90 whitespace-pre-line">{hours}</p>
              </div>
            )}
          </div>

          <div className="space-y-6">
            <div>
              <h3 className="label-orange mb-3">Nous joindre</h3>
              <div className="space-y-4">
                {phone && (
                  <div>
                    <p className="text-sm font-semibold text-foreground mb-1">Téléphone</p>
                    <a
                      href={`tel:${phone.e164}`}
                      className="text-sm text-primary hover:opacity-80 transition-smooth underline-offset-2 hover:underline"
                    >
                      {phone.national}
                    </a>
                  </div>
                )}
                {email && (
                  <div>
                    <p className="text-sm font-semibold text-foreground mb-1">Courriel</p>
                    <a
                      href={`mailto:${email}`}
                      className="text-sm text-primary hover:opacity-80 transition-smooth break-all underline-offset-2 hover:underline"
                    >
                      {email}
                    </a>
                  </div>
                )}
                {privacy?.url && (
                  <a
                    href={privacy.url}
                    target={privacy.target || undefined}
                    className="text-sm text-primary hover:opacity-80 transition-smooth underline-offset-2 hover:underline inline-block"
                  >
                    {privacy.title || "Politique de confidentialité"}
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>

        {menu.length > 0 && (
          <nav className="mt-12 pt-6 border-t border-border/40 flex flex-wrap gap-4 text-xs text-muted-foreground" aria-label="Navigation footer">
            {menu.map((item) => (
              <a key={item.id} href={item.url} className="hover:text-foreground transition-smooth">
                {item.title}
              </a>
            ))}
          </nav>
        )}
      </div>

      <div className="bg-gradient-fire">
        <div className="container py-3 flex items-center justify-between text-xs text-primary-foreground">
          <p>©{year} Tous droits réservés | {siteName}</p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
